module.exports = "<div id=dashboard class=welcome-empty ng-class=style.content> {{:: T.WELCOME_CMS }} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app.home/appHomeView.html
// module id = 1037
// module chunks = 0